<script setup lang="ts">

import { IconCopy } from '@shared/ui/icons'
import { AppSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { AppInput } from '@shared/ui/inputs'
import { AppDatePicker } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useEditPromocode } from '../../model/edit-promocode.hook'

defineOptions({
  name: 'ModalEditPromocode',
})

const {
  isOpen,
  promocode,
  refStatus,
  refExpiresAt,
  statusOptions,
  isSaving,
  isSaveDisabled,
  save,
  cancel,
} = useEditPromocode()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    title="Edit promo code"
    is-close-button
    @click:overlay="cancel"
    @click:close="cancel"
  >
    <div class="modal-promocode">
      <AppSelect
        v-model="refStatus"
        :options="statusOptions"
        label="Status"
        placeholder="Select status"
      />

      <AppInput
        :model-value="`${promocode?.discount ?? ''}%`"
        label="Discount"
        disabled
      />

      <AppDatePicker
        :value="refExpiresAt"
        label="Expires at:"
        placeholder="Eternal"
        @change="refExpiresAt = $event"
      />

      <AppInput
        :model-value="promocode?.name ?? ''"
        label="Create promo code"
        disabled
      >
        <template #append>
          <IconCopy
            :value="promocode?.name ?? ''"
            tooltip="Click to copy code"
          />
        </template>
      </AppInput>
    </div>

    <template #controls>
      <BtnPrimary
        text="Update"
        color="blue"
        :disabled="isSaveDisabled || isSaving"
        @click="save"
      />
      <BtnSecondary
        text="Close"
        @click="cancel"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalEditPromocode.scss" />
